export enum Wind {
	East = 0,
	South,
	West,
	North
}
